import React, { useEffect, useState } from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext, useWatch } from "react-hook-form";
import { GridLegacy, MenuItem, Radio, Alert } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormDatetimeTC from "../../../components/Forms/FormDatetimeTC";
import axios from "axios";

function Pause(props) {
  const { register, setValue } = useFormContext();

  const scheduledActions = useWatch({ name: "scheduled_actions" });
  const [pauseType, setPauseType] = useState(null);
  const [openingOptions, setOpeningOptions] = useState(null);

  useEffect(() => {
    let salesAreaId = props?.vestiging?.id;

    if (salesAreaId) {
      async function fetchOpeningOptions() {
        axios.post("core/vestigingen/nextStartDateTimes", { salesAreaId: props?.vestiging?.id }).then((response) => {
          setOpeningOptions(response?.data?.data);
        });
      }
      fetchOpeningOptions();
    }
  }, [props?.vestiging?.id]);

  const scheduledActionsAlerts = (scheduledActions ?? []).map((scheduledAction) => {
    let alertMsg = "";

    if (scheduledAction.property === "blocked" && scheduledAction.new_value === "0") {
      alertMsg += getTranslation("producten.form.algemeen.alert.at", "At");
      alertMsg += " [" + scheduledAction.execute_at + "] ";
      alertMsg += getTranslation("producten.form.algemeen.label.blocked", "Block in jamezz");
      alertMsg += " ";
      alertMsg += getTranslation("producten.form.algemeen.alert.set_to_false", "will be set to false!");
    } else {
      return "";
    }

    return (
      <Alert severity={"warning"} style={{ marginBottom: "16px" }}>
        {alertMsg}
      </Alert>
    );
  });

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Alert severity={"info"} style={{ marginBottom: "16px" }}>
        <TranslationWrapper
          tDefault={
            " Pausing a product will enable blocked immediately and disable it after the selected time period has passed."
          }
          tKey={"product.form.pause_info"}
        />
      </Alert>
      {scheduledActionsAlerts}
      {(scheduledActions ?? []).length > 0 ? (
        <Alert severity={"warning"} style={{ marginBottom: "16px" }}>
          <TranslationWrapper
            tDefault={"Pausing more than once will overwrite the previous pause!"}
            tKey={"product.form.pause_overwrite_warning"}
          />
        </Alert>
      ) : null}

      <Card style={{ marginBottom: "350px" }}>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <div style={{ display: "flex", paddingBottom: "7px !important" }}>
              <div style={{ paddingRight: "25px" }}>
                <Radio
                  {...register("pp_type")}
                  checked={pauseType === 0}
                  color={"primary"}
                  onClick={() => {
                    setPauseType(0);
                  }}
                  value={pauseType}
                />
                <label>
                  <TranslationWrapper tDefault={"Quick"} tKey={"pause-products.quick"} />
                </label>
              </div>
              {openingOptions !== null ? (
                <div style={{ paddingRight: "25px" }}>
                  <Radio
                    {...register("pp_type")}
                    checked={pauseType === 1}
                    color={"primary"}
                    onClick={() => {
                      setPauseType(1);
                    }}
                    value={pauseType}
                  />
                  <label>
                    <TranslationWrapper tDefault={"Opening hours"} tKey={"pause-products.opening-hours"} />
                  </label>
                </div>
              ) : null}
              <div>
                <Radio
                  {...register("pp_type")}
                  checked={pauseType === 2}
                  color={"primary"}
                  onClick={() => {
                    setPauseType(2);
                  }}
                  value={pauseType}
                />
                <label>
                  <TranslationWrapper tDefault={"Datetime"} tKey={"pause-products.datetime"} />
                </label>
              </div>
            </div>

            {pauseType === 0 ? (
              <FormSelectTC
                defaultValue={"default"}
                name={"pp_quick_select"}
                options={[
                  <MenuItem disabled={true} key={"default"} value={"default"}>
                    <TranslationWrapper
                      tDefault={"Choose how long you wish to pause product for"}
                      tKey={"product.form.pause.select.length.default"}
                    />
                  </MenuItem>,
                  <MenuItem key={"10"} value={"10"}>
                    <TranslationWrapper tDefault={"10 Minutes"} tKey={"product.form.pause.select.length.10m"} />
                  </MenuItem>,
                  <MenuItem key={"30"} value={"30"}>
                    <TranslationWrapper tDefault={"30 Minutes"} tKey={"product.form.pause.select.length.30m"} />
                  </MenuItem>,
                  <MenuItem key={"60"} value={"60"}>
                    <TranslationWrapper tDefault={"1 Hour"} tKey={"product.form.pause.select.length.1h"} />
                  </MenuItem>,
                  <MenuItem key={"120"} value={"120"}>
                    <TranslationWrapper tDefault={"2 Hours"} tKey={"product.form.pause.select.length.2h"} />
                  </MenuItem>,
                  <MenuItem key={"240"} value={"240"}>
                    <TranslationWrapper tDefault={"4 Hours"} tKey={"product.form.pause.select.length.4h"} />
                  </MenuItem>,
                  <MenuItem key={"480"} value={"480"}>
                    <TranslationWrapper tDefault={"8 Hours"} tKey={"product.form.pause.select.length.8h"} />
                  </MenuItem>,
                  <MenuItem key={"tomorrow"} value={"tomorrow"}>
                    <TranslationWrapper
                      tDefault={"Until tomorrow"}
                      tKey={"product.form.pause.select.length.tomorrow"}
                    />
                  </MenuItem>,
                ]}
                tDefault={"Pause product"}
                tKey={"product.form.pause.for"}
              />
            ) : null}

            {pauseType === 1 && openingOptions !== null ? (
              <FormSelectTC
                options={openingOptions.map((openingOption) => (
                  <MenuItem
                    key={JSON.stringify(openingOption)}
                    value={`${openingOption.dayNumber}|${openingOption.startTime}`}
                  >
                    <TranslationWrapper
                      tKey={`pause_product.weekday.${openingOption.dayKey}`}
                      tDefault={openingOption.dayName}
                    />{" "}
                    - {openingOption.startTime}
                  </MenuItem>
                ))}
                tDefault={"Pause product"}
                name={"pp_opening_option"}
                // name={"opening_option_pause_product"}
                tKey={"product.form.pause.openingOptions"}
              />
            ) : null}

            {pauseType === 2 ? (
              <FormDatetimeTC
                name={"pp_datepicker"}
                tDefault={"Pause product until"}
                tKey={"product.form.pause.datepicker"}
              />
            ) : null}
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Pause;
